module.exports = __webpack_public_path__ + "static/media/logofgml.73a3fc6c.png";